'use strict';

var _ = require('lodash');
var SystemStatusUsersListTooltipFactory = function SystemStatusUsersListTooltipFactory() {
  var HIDE_DELAY = 50;
  function SystemStatusUsersListTooltip() {}
  SystemStatusUsersListTooltipFactory.constructor = SystemStatusUsersListTooltip;
  function getHtmlContent(cellData, wholeGridData) {
    var tooltipData = {
      users: wholeGridData[cellData.row][cellData.column + 's']
    };
    var tooltipContent = _.template(require('../templates/system-status-users-list-tooltip.html'));
    return tooltipContent(tooltipData);
  }
  SystemStatusUsersListTooltip.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      if (cellData.value) {
        return {
          htmlContent: getHtmlContent(cellData, wholeGridData),
          hideDelay: HIDE_DELAY,
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  return SystemStatusUsersListTooltip;
};
module.exports = SystemStatusUsersListTooltipFactory;